import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
import { tidSchemaFactory } from "./validation.ts";

/** Where the user came from, used by ProjectHeaderBar to resolve the back-navigation target. */
export const projectNavigationFromSchema = z
  .enum(["tenders", "deals", "chrono-devis", "organisation", "library", "tender-templates", "deal-templates"])
  .optional();

export const projectNavigationOriginSchema = z.object({
  from: projectNavigationFromSchema,
  returnToDealId: tidSchemaFactory("project").optional(),
});

export type ProjectNavigationOrigin = z.infer<typeof projectNavigationOriginSchema>;

export function pickProjectNavigationOrigin(searchParams: unknown): ProjectNavigationOrigin {
  const result = projectNavigationOriginSchema.safeParse(searchParams);
  if (!result.success || !result.data.from) {
    return {};
  }
  if (result.data.from !== "deal-templates") {
    return { from: result.data.from };
  }
  return result.data.returnToDealId ? result.data : {};
}

export const sidebarUrlParamsSchema = projectNavigationOriginSchema.extend({
  sidebarSelectedId: tidSchemaFactory("bidrow").optional(),
  sidebarSelectedIndex: z.number().int().nonnegative().optional(),
});

export type SidebarSelectedId = z.infer<typeof sidebarUrlParamsSchema>["sidebarSelectedId"];

export interface SelectableRow {
  selectableId: Exclude<SidebarSelectedId, undefined>;
}

export const sidebarUrlParamsSchemaValidator = zodValidator(sidebarUrlParamsSchema);

export const importReturnToSchema = z.enum(["work-packages"]).optional();

export const importPageParamsSchemaValidator = zodValidator(
  sidebarUrlParamsSchema.extend({
    returnTo: importReturnToSchema,
  }),
);

export const bidRowDetailsPageParamsSchemaValidator = zodValidator(sidebarUrlParamsSchema);

export const projectBidRowsListPageParamsSchemaValidator = zodValidator(
  sidebarUrlParamsSchema.extend({
    showBasketPopover: z.boolean().optional(),
    bpuSiblingId: tidSchemaFactory("bidrow").optional(),
    bpuPosition: z.enum(["above", "below"]).optional(),
    showOnlyIncomplete: z.boolean().optional(),
  }),
);
